import userResearch from "../Assets/svgs/Ux-Research.svg";
import wireframe from "../Assets/svgs/prototype.svg";
import ui from "../Assets/svgs/ui_Design.svg";
import test from "../Assets/svgs/user_testing.svg";
import interaction from "../Assets/svgs/finger.svg";
import ia from "../Assets/svgs/infomationA.svg";
import html from "../Assets/svgs/html-5.svg";
import js from "../Assets/svgs/java-script.svg";
import react from "../Assets/svgs/react.svg";
import git from "../Assets/svgs/github.svg";
import boot from "../Assets/svgs/bootstrap.svg";
import api from "../Assets/svgs/api.svg";
import { Link } from "react-router-dom";

function Skills({ darkMode }) {
  return (
    <>
      <div className={`h-fit w-full 100:p-6 md:p-16 ${darkMode ? "bg-[#25282b]" : "bg-white"} flex-col justify-start items-center gap-[68px] inline-flex`}>
        {/* Design */}
        <div className={`h-fit 100:flex-col xl:flex-row 100:w-full 2xl:w-[1312px] p-6 ${darkMode ? " bg-[#101316]" : "bg-[#f5f6f6]"} rounded-2xl justify-start lg:items-start xl:items-center 100:items-center gap-8 inline-flex`}>
          {/* Boxes */}
          <div className="md:w-fit 100:w-full 100:flex-wrap lg:w-full flex-1 lg:flex-nowrap justify-start items-start gap-4 inline-flex">
            {/* Row 1 */}
            <div className="md:w-[266px]  lg:flex-grow  100:w-full flex-col justify-start items-start gap-4 inline-flex">
              <div className={`h-[296px] w-full p-4 ${darkMode ? "bg-[#CC95AB]" : "bg-[#ffcae3]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={userResearch} alt="userResearch" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className={`self-stretch ${darkMode ? "text-[#25282B]" : "text-[#40454a]"} text-xl font-semibold font-inter capitalize`}>User experience (UX) Research</h3>
                  <p className={`md:w-[214px] 100:w-full ${darkMode ? "text-[#495055]" : "text-[#555f65]"} text-sm font-normal font-inter capitalize leading-tight`}>
                    Gathering user insights and data to drive informed, user-centered design decisions.
                  </p>
                </div>
              </div>
              <div className={`h-44 w-full p-4 ${darkMode ? "bg-[#9e9dcc]" : "bg-[#d5d5ff]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={wireframe} alt="wireframe" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className="self-stretch text-[#40454a] text-xl font-semibold font-inter capitalize">Wireframing & Prototyping</h3>
                </div>
              </div>
            </div>
            {/* Row 2 */}
            <div className="md:w-[266px]  lg:flex-grow  100:w-full flex-col justify-start items-start gap-4 inline-flex">
              <div className={`h-44 w-full p-4 ${darkMode ? "bg-[#40454a]" : "bg-[#25282b]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={ui} alt="ui" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className={`self-stretch text-[#CCD2D5] text-xl font-semibold font-inter capitalize`}>User Interaction (UI) design</h3>
                </div>
              </div>
              <div className={`h-[296px] w-full p-4 ${darkMode ? "bg-[#BDBDC7]" : "bg-[#f0f0f6]/80"} rounded-2xl shadow border border-[#495055]  flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={test} alt="test" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className={`self-stretch ${darkMode ? "text-[#40454A]" : "text-[#40454a]"} text-xl font-semibold font-inter capitalize`}>User Testing</h3>
                  <p className={`md:w-[214px] 100:w-full ${darkMode ? "text-[#495055]" : "text-[#555f65]"} text-sm font-normal font-inter capitalize leading-tight`}>
                    Conducting tests to enhance user experience, identify pain points, and improve usability.
                  </p>
                </div>
              </div>
            </div>
            {/* Row 3 */}
            <div className="md:w-[266px]  lg:flex-grow  100:w-full flex-col justify-start items-start gap-4 inline-flex">
              <div className={`h-[296px] w-full p-4  ${darkMode ? "bg-[#d6d090]" : "bg-[#fff9c5]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={interaction} alt="interaction" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className={`self-stretch text-[#40454a] text-xl font-semibold font-inter capitalize`}>Interaction Design</h3>
                  <p className="md:w-[214px] 100:w-full text-[#555f65] text-sm font-normal font-inter capitalize leading-tight">Crafting fluid and engaging user interactions that enhance the overall experience and encourage user engagement.</p>
                </div>
              </div>
              <div className={`h-44 p-4 w-full ${darkMode ? "bg-[#a6b8d9]" : "bg-[#d5e4ff]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={ia} alt="ia" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className="self-stretch text-[#40454a] text-xl font-semibold font-inter capitalize">Information Architecture</h3>
                </div>
              </div>
            </div>
          </div>
          <div className="xl:w-[360px]   100:w-full  p-2.5 flex-col justify-start items-start gap-6 inline-flex">
            <h2 className={`self-stretch ${darkMode ? "text-[#e4e7e9]" : "text-[#393c40]"} text-2xl font-semibold font-inter`}>Design Skills: Crafting User-Centered Digital Experiences</h2>
            <p className={`self-stretch ${darkMode ? "text-[#ccd2d5]" : "text-[#555f65]"} text-sm font-normal font-inter capitalize leading-normal`}>
              Conducting comprehensive tests to optimize user experience, identify pain points, and gather actionable insights for improving usability, functionality, and overall satisfaction. <br />
              <br />
              This process ensures designs are refined based on real user feedback and aligned with their needs, leading to a smoother, more intuitive interaction.
            </p>
            <Link onClick={() => window.scrollTo(0, 0)} to="/contact">
              <div className={`h-[43px] px-[25px] hover:bg-[#fd992f]  py-[5px] bg-[#ffb600] rounded-3xl ${darkMode ? " shadow-customWhite" : " shadow-customBlack"}  justify-center items-center gap-2.5 inline-flex`}>
                <div className="text-[#25282b] text-lg font-medium font-inter ">Contact Me</div>
              </div>
            </Link>
          </div>
        </div>
        {/* Development */}
        <div className={`h-fit 100:flex-col xl:flex-row 100:w-full 2xl:w-[1312px] p-6 ${darkMode ? " bg-[#101316]" : "bg-[#f5f6f6]"} rounded-2xl justify-start lg:items-start xl:items-center 100:items-center gap-8 inline-flex`}>
          <div className="xl:w-[360px] 100:w-full  p-2.5 flex-col justify-start items-start gap-6 inline-flex">
            <h2 className={`self-stretch ${darkMode ? "text-[#e4e7e9]" : "text-[#393c40]"} text-2xl font-semibold font-inter`}>Development Skills: Bringing Designs to Life</h2>
            <p className={`self-stretch ${darkMode ? "text-[#ccd2d5]" : "text-[#555f65]"} text-sm font-normal font-inter capitalize leading-normal`}>
              I transform designs into functional, responsive applications using HTML5, CSS3, and JavaScript. <br />
              <br />
              Skilled in React, I create dynamic interfaces and prioritize best practices in version control and API integration to ensure seamless frontend and backend connections.{" "}
            </p>
            <Link onClick={() => window.scrollTo(0, 0)} to="/contact">
              <div className={`h-[43px] px-[25px] hover:bg-[#fd992f]  py-[5px] bg-[#ffb600] rounded-3xl ${darkMode ? " shadow-customWhite" : " shadow-customBlack"}  justify-center items-center gap-2.5 inline-flex`}>
                <div className="text-[#25282b] text-lg font-medium font-inter ">Contact Me</div>
              </div>
            </Link>
          </div>
          {/* Boxes */}
          <div className="md:w-fit 100:w-full 100:flex-wrap lg:w-full flex-1 lg:flex-nowrap justify-start items-start gap-4 inline-flex">
            {/* Row 1 */}
            <div className="md:w-[266px] lg:flex-grow  100:w-full flex-col justify-start items-start gap-4 inline-flex">
              <div className={`h-[296px] w-full p-4 ${darkMode ? "bg-[#9fc5e0]" : "bg-[#caedff]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={html} alt="html" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className="self-stretch text-[#40454a] text-xl font-semibold font-inter capitalize">HTML5 & CSS3</h3>
                  <p className="md:w-[214px] 100:w-full text-[#555f65] text-sm font-normal font-inter capitalize leading-tight">Building responsive, semantic layouts for all screen sizes.</p>
                </div>
              </div>
              <div className={`h-44  p-4 ${darkMode ? "bg-[#e6c2b0]" : "bg-[#ffe6d5]"} w-full rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={js} alt="javascript" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className="self-stretch text-[#40454a] text-xl font-semibold font-inter capitalize">JavaScript</h3>
                </div>
              </div>
            </div>
            {/* Row 2 */}
            <div className="md:w-[266px] lg:flex-grow  100:w-full flex-col justify-start items-start gap-4 inline-flex">
              <div className={`h-44 w-full p-4 ${darkMode ? "bg-[#40454a]" : "bg-[#25282b]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={react} alt="react" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className={`self-stretch text-[#CCD2D5] text-xl font-semibold font-inter capitalize`}>React</h3>
                </div>
              </div>
              <div className={`h-[296px] w-full p-4 ${darkMode ? "bg-[#bdbdc7]" : "bg-[#f0f0f6]/80"} rounded-2xl shadow border border-[#495055]  flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={git} alt="git" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className="self-stretch text-[#40454a] text-xl font-semibold font-inter capitalize">Version Control (Git)</h3>
                  <p className="md:w-[214px] 100:w-full text-[#555f65] text-sm font-normal font-inter capitalize leading-tight">Managing and collaborating on code changes with Git for smooth teamwork and efficient code tracking."</p>
                </div>
              </div>
            </div>
            {/* Row 3 */}
            <div className="md:w-[266px] lg:flex-grow  100:w-full flex-col justify-start items-start gap-4 inline-flex">
              <div className={`h-[296px] w-full p-4 ${darkMode ? "bg-[#b4d99e]" : "bg-[#e0ffc5]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={boot} alt="BootStrap" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className="self-stretch text-[#40454a] text-xl font-semibold font-inter capitalize">CSS Frameworks (Bootstrap, Tailwind)</h3>
                  <p className="md:w-[214px] 100:w-full text-[#555f65] text-sm font-normal font-inter capitalize leading-tight">Utilizing frameworks for quick, consistent designs.</p>
                </div>
              </div>
              <div className={`h-44 w-full p-4 ${darkMode ? "bg-[#d9a8a9]" : "bg-[#ffd5d5]"} rounded-2xl shadow flex-col justify-start items-start gap-4 inline-flex`}>
                <img src={api} alt="api" />
                <div className="w-full p-2.5 flex-col justify-start items-start gap-2.5 inline-flex">
                  <h3 className="self-stretch text-[#40454a] text-xl font-semibold font-inter capitalize">API Integration</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Skills;
